module.exports = __webpack_public_path__ + "static/a-fans-notes-13fd0bf4f379c8456c8e8288287d7b07.jpg";